import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Edit from "rialto-icons/Edit";

import Checkbox from "components/Checkbox";
import IconButton from "components/IconButton";
import PortfolioStatistics from "components/PortfolioStatistics";
import Tooltip from "components/Tooltip";
import Translate from "utils/translate";

import styles from "./PortfolioBlock.css";

const { t } = new Translate("PortfolioBlock");

const PortfolioBlock = (props) => {
  const {
    id,
    isActive,
    isEditable,
    isFake,
    isOwner,
    name,
    onEditPortfolio,
    onMarket,
    onMarketPct,
    onRequestAccessPortfolio,
    onSelectPortfolio,
    rentableArea,
    requestedAccess,
    selectedPortfolioIDs,
    totalAssets,
  } = props;

  const requestAccess = (evt) =>
    requestedAccess ? null : onRequestAccessPortfolio(id) && evt.stopPropagation();
  const edit = (evt) => onEditPortfolio(id) && evt.stopPropagation();

  const handleSelectPortfolio = () => {
    if (isActive) return onSelectPortfolio(selectedPortfolioIDs.filter((s) => s !== id));

    return onSelectPortfolio([...selectedPortfolioIDs, id]);
  };

  return (
    <div
      className={cx(styles.root, {
        [styles.active]: isActive,
        [styles.fake]: isFake,
      })}
      onClick={() => (isFake ? null : handleSelectPortfolio())}
    >
      {!isFake && (
        <div className={styles.checkbox}>
          <Checkbox isChecked={isActive} />
        </div>
      )}
      <div>
        <div className={styles.title}>{name}</div>
        <div className={styles.statistics}>
          <PortfolioStatistics
            isBroker={!isOwner}
            onMarket={onMarket}
            onMarketPct={onMarketPct}
            rentableArea={rentableArea}
            totalAssets={totalAssets}
          />
        </div>
      </div>
      {isFake && (
        <div
          className={cx(styles.requestBtn, {
            [styles.disabled]: requestedAccess,
          })}
          onClick={requestAccess}
        >
          {requestedAccess ? t("requestPending") : t("requestAccess")}
        </div>
      )}
      {isEditable && !isFake && (
        <div className={cx(styles.tooltip)}>
          <Tooltip
            place="left"
            tip={
              <IconButton className={cx(styles.iconEdit)} icon={Edit} onClick={edit} size="small" />
            }
          >
            {t("edit")}
          </Tooltip>
        </div>
      )}
    </div>
  );
};

PortfolioBlock.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  onMarket: PropTypes.shape({
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  onMarketPct: PropTypes.string,
  rentableArea: PropTypes.shape({
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  totalAssets: PropTypes.number,
  requestedAccess: PropTypes.bool,
  onEditPortfolio: PropTypes.func.isRequired,
  onSelectPortfolio: PropTypes.func.isRequired,
  onRequestAccessPortfolio: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isOwner: PropTypes.bool,
  isEditable: PropTypes.bool,
  isFake: PropTypes.bool,
  selectedPortfolioIDs: PropTypes.arrayOf(PropTypes.number),
};

PortfolioBlock.defaultProps = {
  id: 0,
  onMarket: {},
  rentableArea: {},
};

export default PortfolioBlock;
